import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import * as i1 from '@aposin/ng-aquila/icon';
import { DEFAULT_ICONS, NxIconModule } from '@aposin/ng-aquila/icon';
import * as i2 from '@angular/platform-browser';

const SVG_ICONS = {
    'exclamation-circle-warning': '<svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" fill-rule="evenodd" transform="translate(-1 -1)"><path d="m23 12c0-6.075-4.924-11-11-11-6.075 0-11 4.925-11 11 0 .38.02.755.057 1.125.376 3.697 2.583 6.854 5.7 8.548.312.169.632.323.962.463.986.417 2.047.695 3.156.807.371.037.746.057 1.125.057.38 0 .755-.02 1.125-.057 1.11-.112 2.17-.39 3.157-.807.33-.14.65-.294.962-.463 3.117-1.694 5.324-4.851 5.7-8.548.037-.37.056-.745.056-1.125z" fill-rule="nonzero"/><path d="m12.1 15.8c.551 0 1 .45 1 1v.2c0 .55-.449 1-1 1h-.199c-.551 0-1-.45-1-1v-.2c0-.55.449-1 1-1zm.2-9.8c.386 0 .7.315.7.7v6.6c0 .386-.314.7-.7.7h-.599c-.386 0-.701-.314-.701-.7v-6.6c0-.385.315-.7.701-.7z" fill="#414141"/></g></svg>',
};
class NdbxIconModule {
    constructor(iconRegistry, sanitizer) {
        iconRegistry.registerFont('ndbx-icons', 'ndbx-icon', 'nx-icon--');
        iconRegistry.setDefaultFont('ndbx-icons');
        Object.keys(DEFAULT_ICONS).forEach(iconName => iconRegistry.addFontIcon(iconName, '', 'ndbx-icons'));
        Object.entries(SVG_ICONS).forEach(([iconName, literal]) => iconRegistry.addSvgIconLiteral(iconName, sanitizer.bypassSecurityTrustHtml(literal)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.0.1", ngImport: i0, type: NdbxIconModule, deps: [{ token: i1.NxIconRegistry }, { token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.0.1", ngImport: i0, type: NdbxIconModule, imports: [NxIconModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.0.1", ngImport: i0, type: NdbxIconModule, imports: [NxIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.0.1", ngImport: i0, type: NdbxIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [NxIconModule],
                    exports: [],
                    providers: [],
                }]
        }], ctorParameters: function () { return [{ type: i1.NxIconRegistry }, { type: i2.DomSanitizer }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { NdbxIconModule };
